var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3H(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#EB3000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3836 39.52C27.9436 39.52 26.5703 39.2333 25.2636 38.66C23.9569 38.0733 22.8169 37.2533 21.8436 36.2C20.8836 35.1467 20.1969 33.9067 19.7836 32.48L25.0636 31.08C25.3436 32.1333 25.8903 32.9533 26.7036 33.54C27.5303 34.1133 28.4236 34.4 29.3836 34.4C30.2103 34.4 30.9636 34.2 31.6436 33.8C32.3369 33.4 32.8836 32.86 33.2836 32.18C33.6969 31.5 33.9036 30.7467 33.9036 29.92C33.9036 28.68 33.4769 27.62 32.6236 26.74C31.7836 25.8467 30.7036 25.4 29.3836 25.4C28.9836 25.4 28.5969 25.46 28.2236 25.58C27.8503 25.6867 27.4903 25.84 27.1436 26.04L24.7036 21.76L33.8636 14.16L34.2636 15.32H20.9036V10.2H38.9036V15.32L31.7836 22.2L31.7436 20.68C33.3969 20.9333 34.7903 21.5133 35.9236 22.42C37.0703 23.3133 37.9369 24.42 38.5236 25.74C39.1236 27.0467 39.4236 28.44 39.4236 29.92C39.4236 31.7333 38.9636 33.3667 38.0436 34.82C37.1236 36.26 35.9036 37.4067 34.3836 38.26C32.8636 39.1 31.1969 39.52 29.3836 39.52Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 51.0059C25.5612 43.2841 14.25 46.3057 14.25 53.8932C14.25 62.4208 25.9908 65.4424 29.9282 73.3657L29.9998 73.5L30.0714 73.3657C34.0089 65.4424 45.7497 62.4208 45.7497 53.8932C45.8213 46.3057 34.4384 43.2841 29.9998 51.0059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3H);
export default __webpack_public_path__ + "static/media/3h.d56fada4d21d3203ee81b3560b300793.svg";
export { ForwardRef as ReactComponent };